module.exports = __webpack_public_path__ + "fc9911a.worker.js"